import React, { useEffect } from 'react'
import {
  HashRouter,
  Switch,
  Route
} from "react-router-dom"
import BasicRouter from './router'
import Index from './views/Index'
import Login from './views/Login'
import Error from './views/Error'
import Agree from './views/Agree'
import Authentication from './views/Authentication'
import Agreementdetail from './views/Agreementdetail'
import Protocol from './views/Platform/protocol'
import './App.scss'
import { isIE } from './utils/auth'

const getCookie = name => {
  var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)"); //正则匹配
  if(arr=document.cookie.match(reg)){
    return unescape(arr[2]);
  }
  else{
   return null;
  }
}

// 神策全埋点
var sensors = require('sa-sdk-javascript');
sensors.init({
  server_url: 'https://stat.shiyanjia.com/sa?project=' + process.env.REACT_APP_SENSORS,
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  show_log: true,
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect',
    collect_tags: {
      li: true,
      div: true,
      span: true,
    },
  }
});
sensors.registerPage({
  loginsupplierid: getCookie('global_vendorid'),
  supplier_member_id: getCookie('member_id'),
});
sensors.quick('autoTrack'); //用于采集 $pageview 事件。
window.sensors = sensors;

function App() {
  useEffect(() => {
    isIE();
  });
  return (
    <HashRouter>
      <Switch>
        <Route exact path='/login' component={Login} />
        <Route exact path='/404' component={Error} />
        <Route exact path='/authentication' component={Authentication} />
        <Route exact path='/agreementdetail' component={Agreementdetail} />
        <Route exact path='/protocol' render={props => <Protocol {...props} publicView />} />
        <Route exact path='/agree' component={Agree}></Route>
        <BasicRouter path='/' component={Index} />
      </Switch>
    </HashRouter>
  )
};

export default App;
